import styled from "styled-components";

export const HeaderContainer = styled.div`
  ${"" /* background-color: #eee; */}
  height: 15rem;
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: poppins;
  /* padding: 0 5rem; */
`;

export const MainContainer = styled.div`
  row-gap: 0.5rem;
  ${"" /* width: 100%; */}
  display: flex;
  position: relative;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */
`;
export const SubContainer = styled.div`
  /* width: 100%;  */
  display: flex;
  align-items: center;
`;

export const Circle = styled.div`
  position: absolute;
  cursor: pointer;
  height: 60px;
  width: 60px;
  ${"" /* font-size: 28px; */}
  border-radius: 50%;
  background-color: #f4f7fe;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: rgb(0, 100, 0);
`;

export const Line = styled.div`
  width: 160px;
  height: 2px;
  background-color: #e0e0e0;
`;
